import React, { useState, useEffect } from 'react';
import axios from 'axios';
import UsersForm from './form/UsersForm';
import LoadingSpinner from './UI/LoaderSpinner';
import useEndpoints from '../../API/apiConfig';

export default function UsersManager() {
    const endpoints = useEndpoints();
    const [users, setUsers] = useState([]);
    const [currentUser, setCurrentUser] = useState(null);
    const [isLoading, setIsloading] = useState(true);
    const [password, setPassword] = useState('');
    const [showPasswordInput, setShowPasswordInput] = useState(true);
    const [invalidPassword, setInvalidPassword] = useState(false);
    const [isPasswordChecked, setIsPasswordChecked] = useState(false);

    const user = JSON.parse(localStorage.getItem('user'));
    const token = user?.data?.token;

    const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    const fetchUsers = async () => {
        try {
            const response = await axios.get(`${endpoints.ADMINS}?checkPass=${password}`, { headers });
            setUsers(response.data);
            setIsloading(false);
            setInvalidPassword(false);
            setIsPasswordChecked(true);
        } catch (error) {
            console.error("Error fetching users:", error);
            setInvalidPassword(true);
            setIsloading(false);
        }
    };

    const handlePasswordSubmit = async (event) => {
        event.preventDefault();
        await fetchUsers();
    };

    useEffect(() => {
        if (isPasswordChecked && !invalidPassword) {
            setShowPasswordInput(false);
        }
    }, [isPasswordChecked, invalidPassword]);

    const createUser = async (data) => {
        try {
            await axios.post(`${endpoints.CREATE_ADMIN}?checkPass=${password}`, data, { headers });
            fetchUsers();
        } catch (error) {
            console.error("Error creating user:", error);
        }
    };


    const deleteUser = async (id) => {
        await axios.delete(`${endpoints.ADMIN_DELETE}?id=${id}&checkPass=${password}`, { headers });
        fetchUsers();
    };

    return (
        <section className='manager'>
            {showPasswordInput ? (
                <div className="form__item">
                    <label htmlFor="password">Введите пароль</label>
                    <form onSubmit={handlePasswordSubmit}>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                        <button type="submit">Подтвердить</button>
                    </form>
                    {invalidPassword && <p>Неправильный пароль</p>}
                </div>
            ) : (
                <>
                    <h1 className='manager__title'>Управление админами</h1>
                    <UsersForm user={currentUser} onSubmit={createUser} />
                    <h2 className='manager__title_h2'>Список админов</h2>
                    {isLoading ? (
                        <LoadingSpinner />
                    ) : (
                        <ul className='manager__ul'>
                            {users.map(user => (
                                <li className='manager__li' key={user.idUser}>
                                    {user.name}
                                    <div>
                                        <button className='manager__button' onClick={() => deleteUser(user.id)}>Удалить</button>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </>
            )}
        </section>
    );
}